import { RicosViewer } from 'ricos-viewer-next/no-css';
import { createWixRicosViewer } from './WixRicosViewerNext';
export * from '@wix/ricos-common';
export const WixRicosViewer = createWixRicosViewer(RicosViewer);
//# sourceMappingURL=index.no-css.js.map